import _ from "lodash";

/**
 *
 * @param object
 * @param stopKeys A list of keys (in transformed camel case) which when encountered, signal
 *                 that the value at that key should not be transformed using `deepCamelCase`
 * @returns
 */
export function deepCamelCase(object: Object, stopKeys?: string[]) {
    if (Array.isArray(object)) {
        return object.map((obj) => deepCamelCase(obj, stopKeys));
    } else if (
        object != null &&
        object !== undefined &&
        typeof object === "object"
    ) {
        return Object.keys(object).reduce((result, key) => {
            const camelCaseKey = _.camelCase(key);
            const isStopKey = stopKeys?.includes(camelCaseKey);
            return {
                ...result,
                [camelCaseKey]: isStopKey
                    ? object[key]
                    : deepCamelCase(object[key], stopKeys),
            };
        }, {});
    } else {
        return object;
    }
}

/**
 *
 * @param object
 * @param stopKeys A list of keys (in transformed pascal case) which when encountered, signal
 *                 that the value at that key should not be transformed using `deepPascalCase`
 * @returns
 */
export function deepPascalCase(object: Object, stopKeys?: string[]) {
    if (Array.isArray(object)) {
        return object.map((obj) => deepPascalCase(obj, stopKeys));
    } else if (
        object != null &&
        object !== undefined &&
        typeof object === "object"
    ) {
        return Object.keys(object).reduce((result, key) => {
            const pascalCaseKey = key[0].toUpperCase() + key.substring(1);
            const isStopKey = stopKeys?.includes(pascalCaseKey);
            return {
                ...result,
                [pascalCaseKey]: isStopKey
                    ? object[key]
                    : deepPascalCase(object[key], stopKeys),
            };
        }, {});
    } else {
        return object;
    }
}
